import React, { useState } from 'react'
import { Formik, Form } from 'formik';
import { getUserFromToken } from 'src/DecodeToken';
import { AddContainer, Component4, Texts, InputTextComponent, TwoButton, InnerTwoButtons, SaveButton } from './Styles';
import useResponsive from 'src/components/hooks/useResponsive';




function SeoPurposeStep({ innerRef, data, setDoctorProfileData }) {
    const { isMobile, isTablet } = useResponsive();
    const Width = isMobile || isTablet ? '18px' : '24px';
    const Height = isMobile || isTablet ? '18px' : '24px';
    const userId = getUserFromToken();
    const initialValues = {
        profileTitle: data?.profileTitle || '',
        profileMetaKeywords: data?.profileMetaKeywords || '',
        profileDescription: data?.profileDescription || '',
        footerText: data?.footerText || '',
        topKeywords: data?.topKeywords || '',
        user: data?.user || userId
    }
    const handleSubmit = (values) => {
        console.log('Submitted SEO Data:', values);
        setDoctorProfileData(prev => ({
            ...prev,
            seoPurpose: values
        }));
    }
    return (
        <>
            <Formik
                initialValues={initialValues}
                onSubmit={handleSubmit}
                innerRef={innerRef}


            >
                {({ values, errors, touched, handleChange, handleBlur, handleSubmit, setFieldValue }) => (
                    <Form>
                        <AddContainer>
                            <Component4>
                                <Texts>Profile Title</Texts>
                                < InputTextComponent
                                    name="profileTitle"
                                    placeholder="Enter"
                                    variant="outlined"
                                    value={values.profileTitle}
                                    onChange={handleChange}
                                />
                            </Component4>
                            <Component4>
                                <Texts>Profile Meta Keywords</Texts>
                                < InputTextComponent
                                    name="profileMetaKeywords"
                                    placeholder="Enter"
                                    variant="outlined"
                                    value={values.profileMetaKeywords}
                                    onChange={handleChange}
                                />
                            </Component4>
                            <Component4>
                                <Texts>Profile Description</Texts>
                                <InputTextComponent
                                    name="profileDescription"
                                    placeholder="Enter"
                                    variant="outlined"
                                    value={values.profileDescription}
                                    onChange={handleChange}
                                    multiline
                                    rows={3}
                                    sx={{
                                        '& .MuiOutlinedInput-root': {
                                            borderRadius: '12px',
                                            height: '100px',
                                            alignItems: 'flex-start',
                                        },
                                    }}
                                />
                            </Component4>
                            <Component4>
                                <Texts>Footer Text</Texts>
                                < InputTextComponent
                                    name="footerText"
                                    placeholder="Enter"
                                    variant="outlined"
                                    value={values.footerText}
                                    onChange={handleChange}
                                />
                            </Component4>
                            <Component4>
                                <Texts>Top Keywords</Texts>
                                < InputTextComponent
                                    name="topKeywords"
                                    placeholder="Enter"
                                    variant="outlined"
                                    value={values.topKeywords}
                                    onChange={handleChange}
                                />
                            </Component4>
                        </AddContainer>

                    </Form>
                )}
            </Formik>
        </>
    )
}

export default SeoPurposeStep;
